import React from "react";
import { Container, InnerContainer, RootContainer, ErrorRoot, ErrorIconContainer, ErrorMessageContainer, ErrorCode, ErrorMessageTitle, ErrorInformationText, HelpCenter, Link, SignInLink, ErrorButton, } from "./index.styled";
import { ErrorIcon } from "./ErrorIcon";
import { useUser } from "../../../../utils/hooks";
import { navigateTo } from "../../../../utils/common";
const UpSellComponent = ({ authService, }) => {
    const { isAnonymous } = useUser();
    const returnUrl = encodeURIComponent(window.location.href);
    const authUrl = `https://${authService.authService.domain}/login?returnUrl=${returnUrl}`;
    return (React.createElement(Container, null,
        React.createElement(InnerContainer, null,
            React.createElement(RootContainer, null,
                React.createElement(ErrorRoot, null,
                    React.createElement(ErrorIconContainer, null,
                        React.createElement(ErrorIcon, null)),
                    React.createElement(ErrorMessageContainer, null,
                        React.createElement(ErrorCode, null, "ERROR CODE: SONIC-API: MISSING PACKAGE"),
                        React.createElement(ErrorMessageTitle, null, "You will need to be a premium member to watch this video."),
                        isAnonymous && (React.createElement(ErrorInformationText, null,
                            "Already a member? Please",
                            " ",
                            React.createElement(SignInLink, { href: authUrl, rel: "noopener noreferrer", target: "_blank" }, "Sign In"))),
                        React.createElement(ErrorButton, { onClick: () => navigateTo("/go-premium-web") }, "GO PREMIUM"),
                        React.createElement(HelpCenter, null,
                            "Get in touch with us at ",
                            React.createElement(Link, null, "hello@discovery.com"))))))));
};
export default UpSellComponent;

